<template>
  <svg viewBox="0 0 12 12" fill="currentColor">
    <polygon points="2,1 11,6 2,11"/>
  </svg>
</template>
